import axios from '@/axios.js';

export default {
  async fetchKpiMaster({ commit }) {
    const response = await axios.get('sales-and-purchase/drcc/kpi/master');
    const items = (response.data.data || []).map((item) => ({ ...item }));
    commit('SET_MASTER_ITEMS', items);
    return response.data;
  },
  async updateKpiMaster(_, { id, payload }) {
    const response = await axios.put(`sales-and-purchase/drcc/kpi/master/${id}`, payload);
    return response.data;
  },
  async fetchKpiDashboard({ commit }, params) {
    const response = await axios.get('sales-and-purchase/drcc/kpi/dashboard', { params });
    commit('SET_DASHBOARD_DATA', response.data.data || null);
    return response.data;
  },
  async fetchKpiReport({ commit }, params) {
    const response = await axios.get('sales-and-purchase/drcc/kpi/report', { params });
    commit('SET_REPORT_DATA', response.data.data || []);
    return response.data;
  },
  async fetchKpiYearly(_, { year, kpiType }) {
    const response = await axios.get(`sales-and-purchase/drcc/kpi/yearly/${year}`);
    const rows = response.data.data || [];
    const selected = rows.find((row) => row.kpiName === kpiType) || null;
    return {
      ...response.data,
      data: selected,
    };
  },
  async fetchKpiPast3Years({ dispatch }, { toDate, kpiType }) {
    const endYear = new Date(toDate).getFullYear();
    const years = [endYear, endYear - 1, endYear - 2];
    const results = await Promise.all(
      years.map(async (year) => {
        const yearly = await dispatch('fetchKpiYearly', { year, kpiType });
        return {
          year,
          snapshot: yearly.data,
        };
      })
    );
    return {
      success: true,
      data: results,
      meta: { kpiType, years },
    };
  },
};
